import { pillMaterial } from '../product/glassButtons'
import type { TNavCTA } from './types'

/**
 * sx for a CTA wrapper that re-tints the contained UIButton inside it with
 * the portal's filled `pill()` glass in `accent`. The `.MuiButton-root`
 * doubled selector outranks MUI's contained variant and its hover rules.
 */
export function ctaAccentSx(
  accent: NonNullable<TNavCTA['accent']>,
  mode: 'light' | 'dark'
) {
  return {
    '& .MuiButton-root.MuiButton-root': pillMaterial(
      mode,
      accent[mode],
      'filled',
      '#ffffff'
    ),
  }
}
